import React from 'react';
import { Row, Col, Button, Card } from 'react-bootstrap'; 
import Carousel from 'react-bootstrap/Carousel';

function Accueil() {


  return (
    <>
      <style>
        {`
          .carousel-inner {
            border-radius: 0px;
          }
        `}
      </style>
    <header>
      <div id="accueil">
        <div className="header">
          <Carousel >
          <Carousel.Item >
          <Card.Img variant="top" src="/img/accueil3.jpg" style={{height:"auto", maxHeight:"700px"}} />
            <Carousel.Caption >
            <h3>FootProManager</h3>
            <hr/>
            <p> Découvrez une nouvelle façon passionnante de gérer votre équipe  ! </p>
            </Carousel.Caption>
          </Carousel.Item>
          <Carousel.Item >
          <Card.Img variant="top" src="/img/accueil2.jpg" style={{height:"auto", maxHeight:"700px"}} />
            <Carousel.Caption >
            <h3>Plongez dans l'univers du football avec FootProManager !</h3>
            </Carousel.Caption>
          </Carousel.Item>
        </Carousel>
        </div>
      </div>
      </header>
      <div className='accueil'>
        <Row>
          <Col>
            <h2>Fonctionnalités principales</h2>
            <hr/>
          </Col>
        </Row>
        <Row>
          <Col md={4}>
            <Card>
              <Card.Img variant="top" src="/img/milieu_.jpg" />
              <Card.Body>
                <Card.Title>Gestion de l'agenda</Card.Title>
                <Card.Text>
                  Planifiez facilement les entraînements, les matchs et d'autres événements liés à votre équipe.
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4}>
            <Card>
              <Card.Img variant="top" src="/img/accueilArbitre.jpg" />
              <Card.Body>
                <Card.Title>Gestion de l'arbitrage</Card.Title>
                <Card.Text>
                  Suivez les informations sur les arbitres et gérez les affectations pour les matchs de votre équipe.
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4}>
            <Card>
              <Card.Img variant="top" src="/img/coach.jpg" />
              <Card.Body>
                <Card.Title>Communication efficace</Card.Title>
                <Card.Text>
                  Restez en contact avec les membres de votre équipe grâce à des outils de communication intégrés et faciles à utiliser.
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Row className="mt-3">
          <Col>
            <p>D'autres fonctionnalités sont également disponibles ! Venez vite les découvrir.</p>
            <hr/>
          </Col>
        </Row>
        <Row className="mt-5">
          <Col>
            <h2>Rejoignez-nous dès aujourd'hui !</h2>
            <hr/>
            <p>Inscrivez-vous pour découvrir comment FootProManager peut transformer la gestion de votre équipe.</p>
            <Button style={{backgroundColor:"#00E676", borderColor:'#00E676'}}  href='/inscription' variant="primary">Inscrivez-vous maintenant</Button>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default Accueil;
